// extracted by mini-css-extract-plugin
module.exports = {"contactPage":"styles_contactPage__kv0GO","bannerContainer":"styles_bannerContainer__71HVg","questionsIcon":"styles_questionsIcon__m7ORa"};